import store from '@/store/index.js'
export default {
	data () {
		return {
			dfHead:require('../static/img/common/per-img.png'),
			dfHead2:require('../static/img/common/head2.png'),
			dfImg:require('../static/img/common/df-img.png'),
		}
	},
	computed: {
		isMobile(){
			return store.state.isMobile
		},
	},

	methods:{

		clog(type,value){
			if(store.state.debug){
				type = type?type:''
				console.log(type,value)
			}
		},

		goUrl(data,type){	//默认路由跳转
			this.clog(data,'data')
			switch(type){
				case 'out': window.location.href = data; break;	//跳转外部地址（data:页面地址）
				case 'outNew': //跳转外部地址，新窗口打开（data:页面地址）
				  if (/^http(s)?:|^(\/\/)/.test(data)) {
            window.open(data);
          } else {
            window.open('//' + data);
          }
				  break;
				case 'back': this.$router.go(data || -1); break;//返回上一页面（data:返回多少个页面前）
				default:										//本路由内跳转（data:跳转参数）
					this.$router.push(data)
			}
			// if(data){
			// 	//data:url('/index'),object({path:'/index',})
			// 	this.$router.push(data)
			// }
		},

		//列表跳转课程详情页
		goCourseDetail(item){
			// const { courseId, startTime, endTime, termName, termId, offerCourses } = item
			const { courseId, termName, termId } = item
			this.goUrl({name:'courseDetail',params:{ id:courseId }, query:{ termName, termId }})
		},
	}
}



// WEBPACK FOOTER //
// ./src/mixins/index.js